const ROOT_API = process.env.VUE_APP_ROOT_API;

const GET_FO = ROOT_API + "address/get_all_fo.php";
const GET_REGIONS = ROOT_API + "address/get_all_regions.php";
const GET_FORESTRIES = ROOT_API + "address/get_all_forestries.php";
const GET_LOCALFORESTRIES = ROOT_API + "address/get_all_localforestries.php";
const GET_SUBFORESTRIES = ROOT_API + "address/get_all_subforestries.php";
const GET_AREAS = ROOT_API + "address/get_all_areas.php";
const GET_SECTIONS = ROOT_API + "address/get_sections.php";

export default {
  namespaced: true,

  state: {
    selectedFo: null,
    selectedRegion: null,
    selectedForestry: null,
    selectedLocalforestry: null,
    selectedSubforestry: null,
    selectedArea: null,
    selectedSection: null,

    sectionLpExists: false,
    selectedSectionLp: null,
	selectedInspectionType: null,
	
    foList: [],
    regionList: [],
    forestryList: [],
    localforestryList: [],
    subforestryList: [],
    areaList: [],
    sectionList: [],

    loadingFoList: false,
    loadingRegionList: false,
    loadingForestryList: false,
    loadingLocalforestryList: false,
    loadingSubforestryList: false,
    loadingAreaList: false,
    loadingSectionList: false,
  },
  mutations: {
    setSelectedFo(state, payload) {
      state.selectedFo = payload;
    },
    setSelectedRegion(state, payload) {
      state.selectedRegion = payload;
    },
    setSelectedForestry(state, payload) {
      state.selectedForestry = payload;
    },
    setSelectedLocalforestry(state, payload) {
      state.selectedLocalforestry = payload;
    },
    setSelectedSubforestry(state, payload) {
      state.selectedSubforestry = payload;
    },
    setSelectedArea(state, payload) {
      state.selectedArea = payload;
    },
    setSelectedSection(state, payload) {
      state.selectedSection = payload;
    },
    setSectionLpExists(state, payload) {
      state.sectionLpExists = payload;

      if (!state.sectionLpExists) {
        state.selectedSectionLp = null;
      }
    },
    setSelectedSectionLp(state, payload) {
      state.selectedSectionLp = payload;
    },
	setSelectedInspectionType(state, payload) {
      state.selectedInspectionType = payload;
    },
	

    setFoList(state, payload) {
      state.foList = payload;
    },
    setRegionList(state, payload) {
      state.regionList = payload;
    },
    setForestryList(state, payload) {
      state.forestryList = payload;
    },
    setLocalforestryList(state, payload) {
      state.localforestryList = payload;
    },
    setSubforestryList(state, payload) {
      state.subforestryList = payload;
    },
    setAreaList(state, payload) {
      state.areaList = payload;
    },
    setSectionList(state, payload) {
      state.sectionList = payload;
    },
    setListLoading(state, payload) {
      switch (payload) {
        case "foList":
          state.loadingFoList = true;
          break;
        case "regionList":
          state.loadingRegionList = true;
          break;
        case "forestryList":
          state.loadingForestryList = true;
          break;
        case "localforestryList":
          state.loadingLocalforestryList = true;
          break;
        case "subforestryList":
          state.loadingSubforestryList = true;
          break;
        case "areaList":
          state.loadingAreaList = true;
          break;
        case "sectionList":
          state.loadingSectionList = true;
          break;
      }
    },
    unsetListLoading(state, payload) {
      switch (payload) {
        case "foList":
          state.loadingFoList = false;
          break;
        case "regionList":
          state.loadingRegionList = false;
          break;
        case "forestryList":
          state.loadingForestryList = false;
          break;
        case "localforestryList":
          state.loadingLocalforestryList = false;
          break;
        case "subforestryList":
          state.loadingSubforestryList = false;
          break;
        case "areaList":
          state.loadingAreaList = false;
          break;
        case "sectionList":
          state.loadingSectionList = false;
          break;
      }
    },
  },
  actions: {
    selectFo(context, payload) {
      const { state, commit, dispatch } = context;

      commit("setSelectedFo", payload);

      commit("setSelectedRegion", null);
      commit("setSelectedForestry", null);
      commit("setSelectedLocalforestry", null);
      commit("setSelectedSubforestry", null);
      commit("setSelectedArea", null);
      commit("setSelectedSection", null);

      commit("setSectionLpExists", false);
      commit("setSelectedSectionLp", null);

      commit("setRegionList", []);
      commit("setForestryList", []);
      commit("setLocalforestryList", []);
      commit("setSubforestryList", []);
      commit("setAreaList", []);
      commit("setSectionList", []);

      if (state.selectedFo) {
        dispatch("getRegionList");
      }
    },
    selectRegion(context, payload) {
      const { state, commit, dispatch } = context;

      commit("setSelectedRegion", payload);

      commit("setSelectedForestry", null);
      commit("setSelectedLocalforestry", null);
      commit("setSelectedSubforestry", null);
      commit("setSelectedArea", null);
      commit("setSelectedSection", null);

      commit("setSectionLpExists", false);
      commit("setSelectedSectionLp", null);

      commit("setForestryList", []);
      commit("setLocalforestryList", []);
      commit("setSubforestryList", []);
      commit("setAreaList", []);
      commit("setSectionList", []);

      if (state.selectedRegion) {
        dispatch("getForestryList");
      }
    },
    selectForestry(context, payload) {
      const { state, commit, dispatch } = context;

      commit("setSelectedForestry", payload);

      commit("setSelectedLocalforestry", null);
      commit("setSelectedSubforestry", null);
      commit("setSelectedArea", null);
      commit("setSelectedSection", null);

      commit("setSectionLpExists", false);
      commit("setSelectedSectionLp", null);

      commit("setLocalforestryList", []);
      commit("setSubforestryList", []);
      commit("setAreaList", []);
      commit("setSectionList", []);

      if (state.selectedForestry) {
        dispatch("getLocalforestryList");
      }
    },
    selectLocalforestry(context, payload) {
      const { state, commit, dispatch } = context;

      commit("setSelectedLocalforestry", payload);

      commit("setSelectedSubforestry", null);
      commit("setSelectedArea", null);
      commit("setSelectedSection", null);

      commit("setSectionLpExists", false);
      commit("setSelectedSectionLp", null);

      commit("setSubforestryList", []);
      commit("setAreaList", []);
      commit("setSectionList", []);

      if (state.selectedLocalforestry) {
        dispatch("getSubforestryList");
      }
    },
    selectLocalforestryGoFromLpo(context, payload) {
      const { state, commit, dispatch } = context;

      commit("setSelectedLocalforestry", payload);

      commit("setSelectedSubforestry", null);
      commit("setSelectedArea", null);
      commit("setSelectedSection", null);

      commit("setSectionLpExists", false);
      commit("setSelectedSectionLp", null);

      commit("setSubforestryList", []);
      commit("setAreaList", []);
      commit("setSectionList", []);

      if (state.selectedLocalforestry) {
        dispatch("getSubforestryListGoFromLpo");
      }
    },
    selectSubforestry(context, payload) {
      const { state, commit, dispatch } = context;

      commit("setSelectedSubforestry", payload);

      commit("setSelectedArea", null);
      commit("setSelectedSection", null);

      commit("setSectionLpExists", false);
      commit("setSelectedSectionLp", null);

      commit("setAreaList", []);
      commit("setSectionList", []);

      if (state.selectedSubforestry) {
        dispatch("getAreaList");
      }
    },
    selectArea(context, payload) {
      const { state, commit, dispatch } = context;

      commit("setSelectedArea", payload);

      commit("setSelectedSection", null);

      commit("setSectionLpExists", false);
      commit("setSelectedSectionLp", null);

      commit("setSectionList", []);

      if (state.selectedArea) {
        dispatch("getSectionList");
      }
    },
    selectSection(context, payload) {
      const { commit, dispatch } = context;
      commit("setSelectedSection", payload);

      commit("setSectionLpExists", false);
      commit("setSelectedSectionLp", null);
    },
    selectSectionLp(context, payload) {
      const { commit, dispatch } = context;

      if (payload === "") {
        payload = null;
      }

      commit("setSelectedSectionLp", payload);
    },
	selectInspectionType(context, payload) {
      const { commit, dispatch } = context;
      commit("setSelectedInspectionType", payload);
    },

    getFoList(context, payload) {
      const { commit } = context;

      commit("setListLoading", "foList");
      return fetch(GET_FO, {
        credentials: "include",
        method: "post",
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setFoList", res);
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => commit("unsetListLoading", "foList"));
    },
    getRegionList(context, payload) {
      const { state, commit } = context;

      const fo = state.selectedFo;

      const form = new FormData();
      form.append("fo_id", fo.id);

      commit("setListLoading", "regionList");
      return fetch(GET_REGIONS, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setRegionList", res);
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => commit("unsetListLoading", "regionList"));
    },
    getForestryList(context, payload) {
      const { state, commit } = context;

      const fo = state.selectedFo;
      const region = state.selectedRegion;

      const form = new FormData();
      form.append("fo_id", fo.id);
      form.append("region_id", region.id);

      commit("setListLoading", "forestryList");
      return fetch(GET_FORESTRIES, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setForestryList", res);
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => commit("unsetListLoading", "forestryList"));
    },
    getLocalforestryList(context, payload) {
      const { state, commit } = context;

      const fo = state.selectedFo;
      const region = state.selectedRegion;
      const forestry = state.selectedForestry;

      const form = new FormData();
      form.append("fo_id", fo.id);
      form.append("region_id", region.id);
      form.append("forestry_id", forestry.id);

      commit("setListLoading", "localforestryList");
      return fetch(GET_LOCALFORESTRIES, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setLocalforestryList", res);
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => commit("unsetListLoading", "localforestryList"));
    },
    getSubforestryList(context, payload) {
      const { state, commit, dispatch } = context;

      const fo = state.selectedFo;
      const region = state.selectedRegion;
      const forestry = state.selectedForestry;
      const localforestry = state.selectedLocalforestry;

      const form = new FormData();
      form.append("fo_id", fo.id);
      form.append("region_id", region.id);
      form.append("forestry_id", forestry.id);
      form.append("localforestry_id", localforestry.id);

      commit("setListLoading", "subforestryList");
      return fetch(GET_SUBFORESTRIES, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          /* если в списке есть пустой элемент, нужно добавить ему надпись - нет */
          /* и переместить его в начало списка */
          if (res.length && res[res.length - 1].id === null) {
            res[res.length - 1].name = "( нет )";
            res[res.length - 1].isEmpty = true;

            res.unshift(res.pop());
          }

          /* если в списке только пустой элемент */
          /* нужно сразу его выбрать */
          if (res.length === 1 && res[0].id === null) {
            dispatch("selectSubforestry", res[0]);
          }

          commit("setSubforestryList", res);
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => commit("unsetListLoading", "subforestryList"));
    },
    getSubforestryListGoFromLpo(context, payload) {
      const { state, commit, dispatch } = context;

      const form = new FormData();
      form.append("fo_id", state.selectedFo.id);
      form.append("region_id", state.selectedRegion.id);
      form.append("forestry_id", state.selectedForestry.id);
      form.append("localforestry_id", state.selectedLocalforestry.id);

      commit("setListLoading", "subforestryList");
      return fetch(GET_SUBFORESTRIES, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          /* если в списке есть пустой элемент, нужно добавить ему надпись - нет */
          /* и переместить его в начало списка */
          if (res.length && res[res.length - 1].id === null) {
            res[res.length - 1].name = "( нет )";
            res[res.length - 1].isEmpty = true;

            res.unshift(res.pop());
          }

          /* если в списке только пустой элемент */
          /* нужно сразу его выбрать */
          // if (res.length === 1 && res[0].id === null) {
          //   dispatch('selectSubforestry', res[0]);
          // }

          commit("setSubforestryList", res);
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => commit("unsetListLoading", "subforestryList"));
    },
    getAreaList(context, payload) {
      const { state, commit } = context;

      const fo = state.selectedFo;
      const region = state.selectedRegion;
      const forestry = state.selectedForestry;
      const localforestry = state.selectedLocalforestry;
      const subforestry = state.selectedSubforestry;

      const form = new FormData();
      form.append("fo_id", fo.id);
      form.append("region_id", region.id);
      form.append("forestry_id", forestry.id);
      form.append("localforestry_id", localforestry.id);
      form.append("subforestry_id", subforestry.id);

      commit("setListLoading", "areaList");
      return fetch(GET_AREAS, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setAreaList", res);
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => commit("unsetListLoading", "areaList"));
    },
    getSectionList(context, payload) {
      const { state, commit } = context;

      const area = state.selectedArea;

      const form = new FormData();
      form.append("locality_id", area.id);

      commit("setListLoading", "sectionList");
      return fetch(GET_SECTIONS, {
        credentials: "include",
        method: "post",
        body: form,
      })
        .then((res) => res.json())
        .then((res) => {
          commit("setSectionList", res);
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => commit("unsetListLoading", "sectionList"));
    },
  },
};
